import { Ban, Blocks } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      {/* ICON */}
      <div className="mb-4">
        <Ban size={80} color="red" />
      </div>

      {/* TITLE */}
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Access Denied</h1>

      {/* MESSAGE */}
      <p className="text-gray-500 mb-6 text-center max-w-md">
        You don’t have permission to access this page. Please contact your
        administrator if you believe this is a mistake.
      </p>

      {/* BUTTONS */}
      <div className="flex gap-4">
        <button
          onClick={() => navigate("/admindashboard")}
          className="bg-indigo-600 hover:bg-indigo-500 text-white px-6 py-2 rounded-lg font-medium"
        >
          Go to Dashboard
        </button>

        <button
          onClick={() => navigate(-1)}
          className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-2 rounded-lg font-medium"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
